import React from 'react';
import { Code, Network, Shield } from 'lucide-react';

const About = () => {
  const highlights = [
    {
      icon: Network,
      title: 'Cloud & Infrastructure',
      description: 'Building scalable infrastructure using AWS and modern networking principles',
    },
    {
      icon: Code,
      title: 'CI/CD & Automation',
      description: 'Automating workflows and deployments with GitHub Actions and Linux',
    },
    {
      icon: Shield,
      title: 'Security & Networking',
      description: 'Strong foundation in networking and security with Cisco CCNAv7 certification',
    },
  ];

  return (
    <section id="about" className="py-24 px-4 sm:px-6 lg:px-8 bg-slate-900/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4 tracking-tight">About Me</h2>
          <div className="w-20 h-1 bg-[#BCA4E3] mx-auto"></div>
        </div>

        <div className="max-w-3xl mx-auto mb-16">
          <p className="text-lg text-slate-300 leading-relaxed mb-6">
            I'm an aspiring DevOps Engineer with a strong foundation in networking technologies.
            Currently seeking internship opportunities to apply and expand my skills in cloud infrastructure,
            automation, and continuous delivery.
          </p>
          <p className="text-lg text-slate-300 leading-relaxed">
            Passionate about building robust deployment pipelines and infrastructure as code, I'm eager to contribute
            to real-world projects and continue my professional growth in the DevOps and Platform Engineering space.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {highlights.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="group bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 p-8 rounded-xl hover:shadow-xl hover:shadow-[#BCA4E3]/5 hover:border-[#BCA4E3]/30 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex justify-center mb-6">
                  <div className="w-16 h-16 bg-[#BCA4E3]/10 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-8 h-8 text-[#BCA4E3]" />
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-white mb-3 text-center">{item.title}</h3>
                <p className="text-slate-400 text-center leading-relaxed">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
